(() => {
  const notification = document.querySelector('cart-notification');
  const slot = notification?.querySelector('[data-cr-cart-upsell]');
  if (!notification || !slot) return;

  let requestNumber = 0;
  notification.addEventListener('cr:cart-notification-closed', () => {
    requestNumber += 1;
    slot.replaceChildren();
  });

  notification.addEventListener('cr:cart-item-added', async (event) => {
    const productId = Number(event.detail?.productId);
    const currentRequest = ++requestNumber;
    slot.replaceChildren();
    if (!Number.isSafeInteger(productId) || productId <= 0) return;

    const url = new URL(slot.dataset.recommendationsUrl, window.location.origin);
    url.searchParams.set('section_id', 'cr-cart-notification-upsell');
    url.searchParams.set('product_id', String(productId));
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'related');

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = page.querySelector('.cr-cart-upsell__card');
      if (!card || currentRequest !== requestNumber || !notification.notification.classList.contains('active')) return;

      const heading = document.createElement('strong');
      heading.className = 'cr-cart-upsell__heading';
      heading.textContent = slot.dataset.headingLabel;
      slot.replaceChildren(heading, card);
    } catch {
      if (currentRequest === requestNumber) slot.replaceChildren();
    }
  });

  notification.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cr-upsell-add]');
    if (!button || !notification.contains(button) || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    slot.querySelector('.cr-cart-upsell__error')?.remove();

    const form = new FormData();
    form.append('id', String(variantId));
    form.append('quantity', '1');
    form.append('sections', notification.getSectionsToRender().map((section) => section.id).join(','));
    form.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: form,
      });
      const result = await response.json();
      if (!response.ok || result.status || !result.sections) throw new Error('Cart add failed');
      notification.renderContents(result);
      notification.notification.focus();
    } catch {
      button.disabled = false;
      const error = document.createElement('p');
      error.className = 'cr-cart-upsell__error';
      error.setAttribute('role', 'alert');
      error.textContent = slot.dataset.errorLabel;
      slot.append(error);
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
